import { useState } from 'react';
import { AxiosError, AxiosRequestConfig } from 'axios';
import { IRealEstateRatingByPartner } from '../interfaces';
import { getPartnerRatingByRealEstateV2 } from '../api';

export function useGetRealEstateRatingByPartnerV2() {
  const [{ loading, data, error, success }, setData] = useState<{
    loading: boolean;
    error: string | null;
    data: Map<string, IRealEstateRatingByPartner[]>;
    success: boolean;
  }>({ loading: false, error: null, data: new Map(), success: false });

  const fetchRealEstateRatingByPartnerV2 = async (
    partnerGuid: string,
    realEstateGuid: string,
    config: AxiosRequestConfig,
  ) => {
    const mapKey = Object.values(Object.assign({ partnerGuid, realEstateGuid }, config.params))
      .filter(Boolean)
      .join('-');
    if (data.has(mapKey)) return;

    setData((prevState) => ({ ...prevState, loading: true, success: false }));

    try {
      const response = await getPartnerRatingByRealEstateV2(partnerGuid, realEstateGuid, config);

      setData((prevState) => {
        const newData = new Map(prevState.data);
        newData.set(mapKey, response);
        return { ...prevState, data: newData, success: true };
      });
    } catch (error) {
      setData((prevState) => ({ ...prevState, error: (error as AxiosError).response?.data.message }));
    } finally {
      setData((prevState) => ({ ...prevState, loading: false }));
    }
  };

  return { loading, data, error, success, fetchRealEstateRatingByPartnerV2 };
}
